export default class API {
    constructor(client) {
        this.client = client
    }

    createRecord(moduleName, options) {
        const requestKey = 'api.createRecord'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    fetchRecord(moduleName, options) {
        const requestKey = 'api.fetchRecord'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    fetchAll(moduleName, options) {
        const requestKey = 'api.fetchAll'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    updateRecord(moduleName, options) {
        const requestKey = 'api.updateRecord'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    deleteRecord(moduleName, options) {
        const requestKey = 'api.deleteRecord'

        let params = {
            moduleName: moduleName,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    uploadFile(file) {
        const requestKey = 'api.uploadFile'
        const MAX_SIZE = 10 * 1024 * 1024; // 10 MB in bytes

        if (file.size > MAX_SIZE) {
            throw new Error("File size exceeds 10 MB");
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, part
                let params = {
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    encoding: 'base64',
                    data: base64Data
                }
                this.client._postMessageWithPromise(requestKey, params)
                    .then(resolve)
                    .catch(reject);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    fetchAggregatedData(moduleName, options) {
        const requestKey = 'api.fetchAggregatedData'

        let params = {
            moduleName,
            options: options || {}
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }
}